
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_e9sk2_40",
  "outline": "awsui_outline_4yi2u_e9sk2_73",
  "toggle-control": "awsui_toggle-control_4yi2u_e9sk2_95",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_e9sk2_115",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_e9sk2_118",
  "toggle-control-readonly": "awsui_toggle-control-readonly_4yi2u_e9sk2_124",
  "toggle-handle": "awsui_toggle-handle_4yi2u_e9sk2_127",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_e9sk2_152",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_e9sk2_159",
  "toggle-handle-readonly": "awsui_toggle-handle-readonly_4yi2u_e9sk2_163"
};
  